import httpClientImmigration from "@/services/httpClientImmigration";
import { server } from "@/services/constants";

export const getdataByIdim_transaction = (id) => {
  return httpClientImmigration.get(server.IM_TRANSACTION + `/getbyid/${id}`);
};

export const getAllim_transaction_Company = (query) => {
  return httpClientImmigration.get(
    server.IM_TRANSACTION + `/getAllim_transaction_Company`,
    query,
  );
};

export const getAllim_transaction_CompanyPagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
) => {
  return httpClientImmigration.get(
    server.IM_TRANSACTION + `/getAllim_transaction_CompanyPagination`,
    { params: { page, limit, sortBy, sortOrder, company_id } },
  );
};

export const getAllim_transaction_CompanyPaginationV2 = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
  search,
) => {
  return httpClientImmigration.get(
    server.IM_TRANSACTION + `/getAllim_transaction_CompanyPaginationV2`,
    { params: { page, limit, sortBy, sortOrder, company_id, search } },
  );
};

export const getfileno_im_transaction_Company = (query) => {
  return httpClientImmigration.get(
    server.IM_TRANSACTION + `/getfileno_im_transaction_Company`,
    query,
  );
};

export const addim_transaction = (data) => {
  return httpClientImmigration.post(server.IM_TRANSACTION + `/`, data);
};

export const updateim_transaction = (id, data) => {
  return httpClientImmigration.put(server.IM_TRANSACTION + `/${id}`, data);
};

export const updateByfile_noim_transaction = (id, data) => {
  return httpClientImmigration.put(
    server.IM_TRANSACTION + `/updateByfile_no/${id}`,
    data,
  );
};

export const updateByIDtransaction = (id, data) => {
  return httpClientImmigration.put(
    server.IM_TRANSACTION + `/updateByID/${id}`,
    data,
  );
};

export const deleteim_transaction = (id) => {
  return httpClientImmigration.delete(server.IM_TRANSACTION + `/${id}`);
};
